export default function (selector, options) {
    return import(/* webpackChunkName: "swiper" */ 'swiper').then(({ default: Swiper }) => { return new Swiper(selector, options); });
}